import { createTheme } from "@mui/material/styles";
import { FONT_SANS, FONT_DISPLAY } from "./v2Tokens";

const baseTheme = {
  typography: {
    fontFamily: FONT_SANS,
    h1: { fontFamily: FONT_DISPLAY },
    h2: { fontFamily: FONT_DISPLAY },
    h3: { fontFamily: FONT_DISPLAY },
    h4: { fontFamily: FONT_DISPLAY },
  },
  shape: {
    borderRadius: 6,
  },
};

export const v2DarkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: "dark",
    primary: { main: "#3555AA" },
    secondary: { main: "#A7C199" },
    background: {
      default: "#0F1117",
      paper: "#1A1C23",
    },
    text: {
      primary: "#EDEDED",
      secondary: "rgba(255,255,255,0.7)",
    },
    error: { main: "#FB7185" },
    warning: { main: "#FB923C" },
    info: { main: "#47C5E9" },
    success: { main: "#4FA947" },
  },
});

export const v2LightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: "light",
    primary: { main: "#17254A" },
    secondary: { main: "#88AB75" },
    background: {
      default: "#F2F0EF",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#212121",
      secondary: "#666666",
    },
    error: { main: "#E11D48" },
    warning: { main: "#F97316" },
    info: { main: "#0288B5" },
    success: { main: "#4FA947" },
  },
});
